{
  "appName": "22-1995 Education benefits form",
  "entryFile": "./edu-benefits-entry.jsx",
  "entryName": "1995-edu-benefits",
  "rootUrl": "/education/apply-for-education-benefits/application/1995",
  "productId": "2430e3ec-3b99-4086-81b9-9afb2609e75c"
}
